import { IHistoryDateRange } from '@webtrader/core/api/order';
import { getSecondsSinceEpoch } from '@webtrader/core/dayjs';

import { companyService } from '../company';

export const convertDateRangeWithUtcOffset = (dateRange: IHistoryDateRange) => {
  const convertedFrom = companyService
    .convertToDayjsWithOffset({
      input: dateRange.from,
      keepTime: true,
      baseFromOffset: true
    })
    .startOf('day');

  const convertedTo = companyService
    .convertToDayjsWithOffset({
      input: dateRange.to,
      keepTime: true,
      baseFromOffset: true
    })
    .endOf('day');

  const epochFrom = getSecondsSinceEpoch(convertedFrom);
  const epochTo = getSecondsSinceEpoch(convertedTo);

  return {
    epochFrom,
    epochTo
  };
};
